module.exports = __webpack_public_path__ + "static/assets/4d9232fc24395ff39049820e215c9733.png";